import React from "react";

const LockIcon = ({ size = 35, color = "#6D7878", ...props }) => (
  <svg
    width={(27 / 35) * size}
    height={size}
    viewBox="0 0 27 35"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.33333 35C2.41667 35 1.63194 34.6736 0.979167 34.0208C0.326389 33.3681 0 32.5833 0 31.6667V15C0 14.0833 0.326389 13.2986 0.979167 12.6458C1.63194 11.9931 2.41667 11.6667 3.33333 11.6667H5V8.33333C5 6.02778 5.8125 4.0625 7.4375 2.4375C9.0625 0.8125 11.0278 0 13.3333 0C15.6389 0 17.6042 0.8125 19.2292 2.4375C20.8542 4.0625 21.6667 6.02778 21.6667 8.33333V11.6667H23.3333C24.25 11.6667 25.0347 11.9931 25.6875 12.6458C26.3403 13.2986 26.6667 14.0833 26.6667 15V31.6667C26.6667 32.5833 26.3403 33.3681 25.6875 34.0208C25.0347 34.6736 24.25 35 23.3333 35H3.33333ZM3.33333 31.6667H23.3333V15H3.33333V31.6667ZM13.3333 26.6667C14.25 26.6667 15.0347 26.3403 15.6875 25.6875C16.3403 25.0347 16.6667 24.25 16.6667 23.3333C16.6667 22.4167 16.3403 21.6319 15.6875 20.9792C15.0347 20.3264 14.25 20 13.3333 20C12.4167 20 11.6319 20.3264 10.9792 20.9792C10.3264 21.6319 10 22.4167 10 23.3333C10 24.25 10.3264 25.0347 10.9792 25.6875C11.6319 26.3403 12.4167 26.6667 13.3333 26.6667ZM8.33333 11.6667H18.3333V8.33333C18.3333 6.94444 17.8472 5.76389 16.875 4.79167C15.9028 3.81944 14.7222 3.33333 13.3333 3.33333C11.9444 3.33333 10.7639 3.81944 9.79167 4.79167C8.81944 5.76389 8.33333 6.94444 8.33333 8.33333V11.6667Z"
      fill={color}
    />
  </svg>
);

export default LockIcon;
